import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import Settings from "@/features/notifications/settings";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute(
  "/_auth/_app-shell/notifications/settings",
)({
  component: RouteComponent,
  validateSearch: z.object({ code: z.string().optional() }),
});

//generate release
function RouteComponent() {
  usePageTitle("Notification Settings");

  return <Settings />;
}
